import { Link } from 'react-router-dom';

const features = [
  {
    title: '3D Game Editor',
    body: 'Build scenes in the browser with real-time geometry, lighting, and an orbit camera.',
    glyph: '◳',
  },
  {
    title: 'Web3 Native',
    body: 'Own what you create. On-chain identity and assets are built into the foundation.',
    glyph: '◈',
  },
  {
    title: 'AI-Assisted',
    body: 'Generation and assistance powered by a multi-provider AI engine, surfaced where you work.',
    glyph: '✦',
  },
  {
    title: 'Export & Share',
    body: 'Take your creations anywhere — publish, share, and ship to the web.',
    glyph: '➤',
  },
];

export default function LandingPage() {
  return (
    <div
      className="min-h-screen w-full text-white overflow-x-hidden"
      style={{
        background:
          'radial-gradient(1200px 600px at 50% -10%, rgba(43,140,255,0.18), transparent 60%),' +
          'radial-gradient(900px 500px at 85% 20%, rgba(124,58,237,0.18), transparent 55%),' +
          '#070710',
      }}
    >
      <nav className="flex items-center justify-between px-6 md:px-12 py-5 max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <img src="/yip-logo.png" alt="YIP" className="h-9 w-9" />
          <span className="text-lg font-bold tracking-tight">
            YIP<span className="text-blue-400">.fun</span>
          </span>
        </div>
        <button
          type="button"
          className="text-sm text-gray-300 hover:text-white border border-white/15 hover:border-white/35 rounded-lg px-4 py-2 transition-colors"
        >
          Sign In
        </button>
      </nav>

      <header className="max-w-5xl mx-auto px-6 pt-16 md:pt-24 pb-20 text-center">
        <div className="relative inline-block mb-8">
          <div
            className="absolute inset-0 blur-3xl opacity-60"
            style={{
              background:
                'radial-gradient(circle, rgba(43,140,255,0.55), rgba(124,58,237,0.35) 60%, transparent 70%)',
            }}
          />
          <img
            src="/yip-logo.png"
            alt="YIP logo"
            className="relative h-28 w-28 md:h-36 md:w-36 mx-auto"
          />
        </div>

        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight">
          Build 3D games,{' '}
          <span
            className="bg-clip-text text-transparent"
            style={{ backgroundImage: 'linear-gradient(90deg, #2B8CFF, #7C3AED)' }}
          >
            right in your browser
          </span>
        </h1>
        <p className="mt-6 text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">
          YIP Studio is a Web3-native game creation platform. Model a scene,
          shape it in real time, and own everything you make.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/editor"
            className="w-full sm:w-auto px-8 py-3 rounded-xl font-semibold text-white shadow-lg transition-transform hover:scale-[1.03]"
            style={{
              backgroundImage: 'linear-gradient(90deg, #2B8CFF, #7C3AED)',
              boxShadow: '0 10px 40px -10px rgba(124,58,237,0.6)',
            }}
          >
            Open Studio
          </Link>
          <button
            type="button"
            className="w-full sm:w-auto px-8 py-3 rounded-xl font-semibold border border-white/20 hover:border-white/40 hover:bg-white/5 transition-colors flex items-center justify-center gap-2"
          >
            Connect Wallet
            <span className="text-[10px] uppercase tracking-wider text-blue-300 border border-blue-400/40 rounded px-1.5 py-0.5">
              Soon
            </span>
          </button>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:border-white/25 hover:bg-white/[0.06] transition-colors"
            >
              <div
                className="text-2xl mb-4 h-11 w-11 flex items-center justify-center rounded-xl"
                style={{ backgroundImage: 'linear-gradient(135deg, rgba(43,140,255,0.25), rgba(124,58,237,0.25))' }}
              >
                {f.glyph}
              </div>
              <h3 className="font-semibold text-lg mb-2">{f.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>
      </section>

      <footer className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-500">
          <div className="flex items-center gap-2">
            <img src="/yip-logo.png" alt="" className="h-5 w-5" />
            <span>YIP.fun — create, own, play.</span>
          </div>
          <span>© {new Date().getFullYear()} YIP. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
